import { DayOfWeek } from '@orderna/admin-panel/src/types/day-of-week';
import {
  DayOpeningHours,
  OpeningHours,
  TimeRange,
} from '../../model/opening-hours';
import { Stores } from '../../model/stores';
import { StoresProductSummary } from '../../model/stores-product-summary';
import { DAYS_OF_WEEK } from '@orderna/admin-panel/src/types/day-of-week';
import { TimeSlotIdGenerator } from '@orderna/admin-panel/src/utils/timeslots';

export class StoresApiMapper {
  static toStores(api: any): Stores {
    return {
      data: api.items.map((i: any) => ({
        id: i.id,
        name: i.name,
        telephone: i.telephone
          ? {
              countryCode: i.telephone.countryCode,
              number: i.telephone.number,
            }
          : null,
        mobile: i.mobile
          ? {
              countryCode: i.mobile.countryCode,
              number: i.mobile.number,
            }
          : null,
        address: i.address
          ? {
              unitFloorRoomBuildingNo: i.address.unitFloorRoomBuildingNo,
              buildingNameTower: i.address.buildingNameTower,
              lotBlockPhaseHouseNo: i.address.lotBlockPhaseHouseNo,
              street: i.address.street,
              subdivisionVillageZone: i.address.subdivisionVillageZone,
              barangay: i.address.barangay,
              district: i.address.district,
              city: i.address.city,
              province: i.address.province,
              zipCode: i.address.zipCode,
            }
          : null,
        hasProducts: i.hasProducts,
      })),
      count: api.meta.total,
    };
  }

  static toStoresProductSummary(api: any): StoresProductSummary {
    return {
      products: api.items.map((i: any) => ({
        store: {
          id: i.id,
          name: i.name,
          createdAt: i.createdAt,
        },
        categoryCount: i.productSummary.categoryCount,
        productCount: i.productSummary.count,
        imageCount: i.productSummary.imageCount,
        descriptionCount: i.productSummary.descriptionCount,
      })),
      totalRecord: api.meta.total,
    };
  }

  // TODO: Move to separate file
  static toOpeningHours(api: any): OpeningHours {
    return DAYS_OF_WEEK.reduce((acc, day) => {
      const {
        id,
        timeSlots = [],
        isClosed = false,
        is24Hours = true,
      } = api[day] ?? {};

      acc[day] = {
        id,
        timeSlots:
          timeSlots?.map(
            (s: any): TimeRange => ({
              id: TimeSlotIdGenerator.generate(),
              from: {
                hours: s.open.split(':')[0],
                minutes: s.open.split(':')[1],
              },
              to: {
                hours: s.close.split(':')[0],
                minutes: s.close.split(':')[1],
              },
            })
          ) ?? [],
        isClosed,
        is24Hours,
      };
      return acc;
    }, {} as Record<DayOfWeek, DayOpeningHours>);
  }

  static fromOpeningHours(data: OpeningHours): any {
    return DAYS_OF_WEEK.reduce((acc, day) => {
      const { timeSlots, isClosed, is24Hours } = data[day];

      acc[day] = { isClosed, is24Hours };

      if (Array.isArray(timeSlots) && timeSlots.length > 0) {
        acc[day] = {
          ...acc[day],
          timeSlots: timeSlots.map((s: TimeRange): any => ({
            open: `${s.from.hours}:${s.from.minutes}`,
            close: `${s.to.hours}:${s.to.minutes}`,
          })),
        };
      }

      return acc;
    }, {} as Record<DayOfWeek, any>);
  }
}
